// Mise en forme légère utilisée pour le texte des horaires (et sa prévisualisation
// dans l'adminpanel) : /*texte*/ -> gras, //texte// -> italique, retour à la
// ligne (Entrée dans le textarea) -> <br/>.
export function applyFormatting(text) {
    if (!text) return '';
    let result = text;
    result = result.replace(/\/\*(.*?)\*\//g, '<strong>$1</strong>');
    result = result.replace(/\/\/(.*?)\/\//g, '<em>$1</em>');
    result = result.replace(/\n/g, '<br/>');
    return result;
}
